module.exports = __webpack_public_path__ + "static/media/tutorial5.eee368a3.png";